import { joinClass as joinClassAPI } from "../api";

export const joinClassAction = async (
  userID,
  classID,
  setUser,
  setAssignment,
  setQuestion
) => {
  const user = await joinClassAPI(userID, classID);
  setUser(user.data);
  setAssignment(user?.data?.classes[0]?.assignments[0]);
  setQuestion(user?.data?.classes[0]?.assignments[0]?.questions[0]);
};
